<button class="w-full border-b border-border-tertiary p-3! text-left" tuiCell type="button" (click)="toggle()">
  @if (item().previewUrl; as previewUrl) {
    <video
      class="size-10 shrink-0 rounded-sm object-cover"
      muted
      preload="metadata"
      [src]="previewUrl + '#t=0.1'"></video>
  } @else {
    <img class="size-10 shrink-0 object-cover" [alt]="item().title" [src]="item().thumbnailUrl" />
  }
  <span class="min-w-0" tuiTitle>
    <span class="block truncate" data-testid="title" [tuiSkeleton]="isTitleUnresolved() && 20">{{ item().title }}</span>
    @let date = item().date;
    @let clientName = item().clientName;
    @if (isTitleUnresolved()) {
      <span class="block truncate" data-testid="subtitle" tuiSubtitle [tuiSkeleton]="10"></span>
    } @else if (date || clientName) {
      <span class="flex gap-1 truncate" tuiSubtitle>
        @if (date) {
          <span class="shrink-0">{{ date | date: 'short' }}</span>
        }
        @if (date && clientName) {
          <span aria-hidden="true" class="shrink-0">·</span>
        }
        @if (clientName) {
          <span class="truncate">{{ clientName }}</span>
        }
      </span>
    }
  </span>
  <span class="flex shrink-0 items-center gap-2">
    <pxc-sync-global-status-icon variant="detailed" [progress]="item().state.progress" [status]="item().state.status" />
    <tui-icon
      class="text-foreground-quaternary transition-transform duration-300"
      icon="@tui.chevron-down"
      [class.rotate-180]="isExpanded()" />
  </span>
</button>

<tui-elastic-container>
  @if (isExpanded()) {
    <div class="flex flex-col gap-2 p-3">
      @for (child of item().children; track child.childId) {
        <pxc-sync-center-child
          [child]="child"
          (delete)="onDeleteChild(child)"
          (resume)="onResumeChild(child)"
          (retry)="onRetryChild(child)" />
      }
    </div>
  }
</tui-elastic-container>
